export default __webpack_public_path__ + "static/item_06-da17091be4b856cbea7c63295dc53eec.jpg";